<div class="calendar-div">
    <p-calendar appendTo="body" [disabled]="disabled" [(ngModel)]="dateValue" [dateFormat]="dateFormat" [view]="view" [showIcon]="true" inputId="dateformat" [defaultDate]="highlightDate" (onSelect)="onSelect()"></p-calendar>
</div>
